<template>
  <div class="header">
    <h1 v-if="!isLink">
      {{ title }}
    </h1>
    <h1 v-if="isLink">
      <router-link :to="{name: 'TemplateBuilder', query: backQuery}">
        <font-awesome-icon
          :icon="['far', 'chevron-left']"
          size="lg"
        />  {{ title }}
      </router-link>
    </h1>
  </div>
</template>
<script>

export default {
  props: {
    title: String,
    isLink: Boolean
  },
  data () {
    const backQuery = this.$helpers.getTemplateBuilderQuery(this.$route, false)
    delete backQuery.templateId
    return {
      backQuery
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  h1 {
    color: #000;
    a {
      text-decoration: none;
      color: #000;
      cursor: pointer;
      .fa-lg {
        vertical-align: -0.2rem;
        margin-right: 7px;
        color: #24245A;
      }
    }
  }
}

</style>
